<div class="migrations-container table-bottom-padding">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-breadcrumbs></ziro-breadcrumbs>

    <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
      <div class="d-flex flex-wrap align-items-center gap-2" data-automation="sites-overview-status-filters">
        <span class="fs-6 text-muted me-1">
          {{ 'tkey;migrations.sites_overview.status_filter.label' | translate }}
        </span>
        @for (option of statusFilterOptions; track option.status) {
          <ziro-button
            [dataAutomation]="'sites-overview-status-filter-' + option.status"
            [label]="option.label"
            [buttonStyle]="option.isActive ? ButtonStyles.OUTLINE_INFO : ButtonStyles.OUTLINE_SECONDARY"
            [cssClass]="'status-filter-button'"
            (clicked)="onStatusFilterClick(option.status)"
          ></ziro-button>
        }
      </div>

      <div class="d-flex align-items-center gap-2" data-automation="sites-overview-bar-mode-toggle">
        <span class="fs-6 text-muted">
          {{ 'tkey;migrations.sites_overview.bar_mode.label' | translate }}
        </span>
        <ziro-button
          [dataAutomation]="'sites-overview-bar-mode-full-width'"
          [label]="'tkey;migrations.sites_overview.bar_mode.full_width.label'"
          [buttonStyle]="
            getBarMode() === SiteBarMode.FULL_WIDTH ? ButtonStyles.OUTLINE_INFO : ButtonStyles.OUTLINE_SECONDARY
          "
          (clicked)="onBarModeChange(SiteBarMode.FULL_WIDTH)"
        ></ziro-button>
        <ziro-button
          [dataAutomation]="'sites-overview-bar-mode-proportional'"
          [label]="'tkey;migrations.sites_overview.bar_mode.proportional.label'"
          [buttonStyle]="
            getBarMode() === SiteBarMode.PROPORTIONAL ? ButtonStyles.OUTLINE_INFO : ButtonStyles.OUTLINE_SECONDARY
          "
          (clicked)="onBarModeChange(SiteBarMode.PROPORTIONAL)"
        ></ziro-button>
      </div>
    </div>

    @if (chips.length) {
      <div class="d-flex flex-wrap align-items-center gap-2 mb-3" data-automation="sites-overview-filter-chips">
        @for (chip of chips; track chip.key) {
          <span class="filter-chip" [attr.data-automation]="'sites-overview-chip-' + chip.key">
            <span class="filter-chip--swatch" [style.background-color]="chip.color"></span>
            <span>{{ chip.label }}</span>
            <ziro-button
              [dataAutomation]="'sites-overview-chip-remove-' + chip.key"
              [buttonStyle]="ButtonStyles.LINK"
              [icon]="ZiroIcons.TIMES"
              [cssClass]="'filter-chip--remove'"
              (clicked)="onChipRemoved(chip)"
            ></ziro-button>
          </span>
        }
      </div>
    }

    <ziro-datatable
      #datatable
      [columns]="columns"
      [rowDataSource]="rows"
      [uniqueRowIdentifier]="'id'"
      [dataAutomation]="'sites-overview-table'"
      [mainFilterPlaceholder]="'tkey;migrations.sites_overview.table.filter.placeholder' | translate"
      [resetPageOnDataChange]="false"
      [setColumnWidths]="true"
      [verticalAlignCellMiddle]="true"
      [class]="'ziro-card'"
    ></ziro-datatable>
  }

  <ng-template #siteBarCell let-row="row">
    @if (row.progress.segments.length) {
      <div
        class="site-bar"
        [style.width.%]="getBarWidthPercent(row)"
        [attr.data-automation]="'site-bar-' + row.siteId"
        (click)="onRowBarClick(row)"
      >
        @for (segment of row.progress.segments; track segment.status) {
          <span
            class="site-bar--segment"
            [style.width.%]="segment.percentOfSite"
            [style.background-color]="segment.color"
            [ngbTooltip]="getSegmentTooltip(row, segment)"
            [attr.data-automation]="'site-bar-segment-' + segment.status"
            (click)="onSegmentClick(row, segment, $event)"
          ></span>
        }
      </div>
    } @else {
      <span class="site-bar--empty" data-automation="site-bar-empty">
        {{ 'tkey;migrations.sites_overview.bar.no_directory_numbers' | translate }}
      </span>
    }
  </ng-template>
</div>
